import { Group, Stack, Switch, TagsInput, TextInput } from '@mantine/core'
import { useForm, zodResolver } from '@mantine/form'
import Form from 'common/Form'
import { useRoles } from 'hooks/users'
import { userSchema } from 'types/schemas'
import { UpdateUser } from 'types/users'
import { trimFormValues } from 'utils'

type Props = {
  onSubmit: (values: UpdateUser) => void
  onCancel: () => void
  initialValues: UpdateUser
}

export function UpdateUserForm({ onSubmit, onCancel, initialValues }: Props) {
  const form = useForm<UpdateUser>({
    initialValues: initialValues,
    validate: zodResolver(userSchema),
    transformValues: trimFormValues,
  })
  const { data: roles } = useRoles()

  const { error, ...allowedIPsInputProps } = form.getInputProps('allowedIPs')
  const allowedIPsError = Object.entries(form.errors).find(([key]) => {
    return key.startsWith('allowedIPs')
  })?.[1]

  return (
    <Form onSubmit={onSubmit} form={form} onCancel={onCancel} submitText="Edytuj użytkownika">
      <Stack gap="xs">
        <TextInput label="Imię" placeholder="Jan" withAsterisk {...form.getInputProps('firstName')} />
        <TextInput label="Nazwisko" placeholder="Kowalski" withAsterisk {...form.getInputProps('lastName')} />
        <TextInput label="Nazwa użytkownika" placeholder="jkowalski" withAsterisk {...form.getInputProps('username')} />
        <TagsInput
          label="Dozwolone adresy IP"
          placeholder="192.168.0.1"
          description="Użytkownik będzie mógł się logować tylko z tych adresów IP. Jeśli pole jest puste, użytkownik nie będzie mógł się zalogować, chyba że jest Adminem."
          {...allowedIPsInputProps}
          error={allowedIPsError}
        />
        <Switch
          label="Konto aktywne"
          description="Jeśli konto jest nieaktywne to nie można się do niego zalogować"
          {...form.getInputProps('active', { type: 'checkbox' })}
        />
        <Switch.Group label="Role" description="Uprawnienia użytkownika" {...form.getInputProps('roles')}>
          <Group mt="xs">
            {roles.map((role) => (
              <Switch key={role.id} value={role.id} label={role.name} />
            ))}
          </Group>
        </Switch.Group>
      </Stack>
    </Form>
  )
}
